module.exports = __webpack_public_path__ + "img/img_kb_type2_slide01.34edaf55.png";